export const SALESIQ_WIDGET_URL =
  'https://salesiq.zohopublic.com/widget?wc=siqf513f6e297a40ad559ffe7a9dede30bcd8f34a0fdbe605db26fd1ce484097825';

export const SALESIQ_WHATSAPP_URL =
  'https://wa.me/918448027888?text=Hi%20Team%2C%20I%20need%20assistance.%20Could%20you%20please%20assist%3F';

export const SALESIQ_BOOTSTRAP_SCRIPT =
  'window.$zoho=window.$zoho || {};$zoho.salesiq=$zoho.salesiq||{ready:function(){}}';

const SCRIPT_ID_BOOTSTRAP = 'zoho-salesiq-bootstrap';
const SCRIPT_ID_WIDGET = 'zsiqscript';

function getSalesIQReadyScript(): string {
  const whatsappUrl = SALESIQ_WHATSAPP_URL.replace(/'/g, "\\'");
  return [
    '$zoho.salesiq.ready=function(){',
    "  $zoho.salesiq.set('home.widgets',[",
    '    {',
    '      type:"action_item",',
    '      title:"WhatsApp",',
    '      icon:{type:"channel",name:"whatsapp",url:"' + whatsappUrl + '"}',
    '    }',
    '  ]);',
    '};',
  ].join('');
}

export function loadSalesIQ(): void {
  if (typeof document === 'undefined' || !document.head) return;

  const doc = document;

  if (!doc.getElementById(SCRIPT_ID_BOOTSTRAP)) {
    const bootstrap = doc.createElement('script');
    bootstrap.id = SCRIPT_ID_BOOTSTRAP;
    bootstrap.textContent = SALESIQ_BOOTSTRAP_SCRIPT + '\n' + getSalesIQReadyScript();
    doc.head.appendChild(bootstrap);
  }

  if (!doc.getElementById(SCRIPT_ID_WIDGET)) {
    const widget = doc.createElement('script');
    widget.id = SCRIPT_ID_WIDGET;
    widget.src = SALESIQ_WIDGET_URL;
    widget.defer = true;
    doc.head.appendChild(widget);
  }
}
